import { render, staticRenderFns } from "./EnrollmentNav.vue?vue&type=template&id=20810140&scoped=true"
import script from "./EnrollmentNav.vue?vue&type=script&lang=js"
export * from "./EnrollmentNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20810140",
  null
  
)

export default component.exports